import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { components } from "@/api/schema";
import { RequestError } from "./queries";

/** Страница базы знаний (SP-KB): заметка из Notes/**, на которую ведут «Заметки менторов» шага. */
export type KbPage = components["schemas"]["KbPage"];

export function useNote(slug: string) {
  return useQuery({
    queryKey: ["notes", slug],
    queryFn: async () => {
      const { data, error, response } = await api.GET("/notes/{slug}", { params: { path: { slug } } });
      if (!data) {
        const e = error as { error?: string; message?: string } | undefined;
        throw new RequestError(response.status, e?.error ?? "unknown", e?.message ?? "Не удалось загрузить страницу.");
      }
      return data;
    },
    staleTime: 5 * 60_000,
    retry: false,
  });
}
